'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Loader = require('./Loader.scss');

var _Loader2 = _interopRequireDefault(_Loader);

var _Label = require('../../managewidgets/components/label/Label');

var _Label2 = _interopRequireDefault(_Label);

var _LinearProgressBar = require('../../managewidgets/components/linearprogressbar/LinearProgressBar');

var _LinearProgressBar2 = _interopRequireDefault(_LinearProgressBar);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loader = function Loader(props) {
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(props.className, _Loader2.default.content) },
    _react2.default.createElement(_Label2.default, { className: _Loader2.default.title, value: 'Loading...' }),
    _react2.default.createElement(_LinearProgressBar2.default, { className: _Loader2.default.progress })
  );
};

exports.default = Loader;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/loader/Loader.js
// module id = 745
// module chunks = 10